module.exports = __webpack_public_path__ + "assets/img/03.8b71cee5.jpg";